import { Injectable, inject } from '@angular/core'
import { Route, Router, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthService } from '../services/auth.service'

@Injectable()
export class AuthGuard {
  private auth = inject(AuthService)
  private router = inject(Router)

  canActivate(): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    const customer = this.auth.customer()
    if (customer && this.auth.isNewCustomer) {
      return this.auth.isSetupRequired()
        ? this.router.parseUrl('/dashboard-visa/setup')
        : this.router.parseUrl('/dashboard-visa')
    }
    return customer ? true : this.router.parseUrl('/mypages/login')
  }

  canLoad(route: Route): boolean {
    // istanbul ignore next
    return route.path!.startsWith('mypages') ?? false
  }
}
